import { useQuery } from "@tanstack/react-query";

import { getFootprintingDairyRefrigerantUsage, getFootprintingDairyRefrigerantUsageAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_DAIRY_REFRIGERANT_USAGE } from "consts";

export const useGetFootprintingDairyRefrigerantUsage = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;

  return useQuery({
    queryKey: [FOOTPRINTING_DAIRY_REFRIGERANT_USAGE, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getFootprintingDairyRefrigerantUsageAdmin(primaryDataId ?? "") : getFootprintingDairyRefrigerantUsage(primaryDataId ?? "")),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
};
